/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCulturalFestivalTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCulturalFestival,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Celebrate Culture Together!",
    "Cultural Festival Awaits!",
    "Experience Diversity and Fun!",
  ],
  title: "Cultural Festival",
  description: "Organize a fun cultural festival.",
  longDescription:
    "Gather your community for an exciting cultural festival! Choose a date, decide on activities, and plan refreshments!",
  emoji: "🎉",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Cultural Festival",
          emoji: "🎉",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the cultural festival?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to include?",
            description:
              "What activities should we focus on during the festival?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🌍",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we prepare for the festival?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍽",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Celebrate Culture Together!",
    outroDescription:
      "Your cultural festival plans are set! Enjoy the festivities!",
  },
};
